import React from 'react';
import { useNavigate } from 'react-router-dom';
import useSEO from '../hooks/useSEO';
import { FlowPage, Icon } from '../components/bx';
import '../styles/bx.css';
import '../styles/home.css';

interface PathSelectionPageProps {
  onSubscribe: (category: 'consumer' | 'b2b') => void;
  onGetMe?: () => void;
  onStartSurprise?: () => void;
  onLogoClick?: () => void;
}

const PATHS = [
  {
    key: 'consumer' as const,
    image: require('../assets/images/calm_path.png'),
    tag: 'For homes & families',
    title: 'Quiet Monthly Peace',
    text: 'Personal and family subscriptions — essentials and hygiene care delivered discreetly to your door.',
    points: ['Weekly or monthly deliveries', 'Choose a plan or build your own', 'Pick your drop-off day'],
    cta: 'Browse household plans',
  },
  {
    key: 'b2b' as const,
    image: require('../assets/images/quiet_stock_peace.png'),
    tag: 'For resellers',
    title: 'Quiet Stock Peace',
    text: 'Daily stock for your selling spot — egg rolls, scotch eggs, sausage rolls, snacks and drinks.',
    points: ['Daily or every-other-day restocks', 'Pay daily or monthly', 'Delivered to your selling spot'],
    cta: 'Browse reseller plans',
  },
];

export default function PathSelectionPage({ onSubscribe }: PathSelectionPageProps) {
  const navigate = useNavigate();
  useSEO({
    title: 'Subscriptions - BOQBOX',
    description: 'Household restocks or daily stock for your business — pick the BOQBOX subscription that fits you.',
  });

  return (
    <FlowPage
      eyebrow="Subscriptions"
      title="Choose your path to peace"
      subtitle="Set it once and we keep you stocked. Every delivery arrives in a plain, unlabelled bag."
      onBack={() => navigate('/')}
      backLabel="Home"
    >
      <div className="bx-hub">
        {PATHS.map((p) => (
          <button key={p.key} type="button" className="bx-hub-card" onClick={() => onSubscribe(p.key)}>
            <div className="bx-hub-img">
              <img src={p.image} alt="" />
              <span className="bx-pill">{p.tag}</span>
            </div>
            <div className="bx-hub-body">
              <h2>{p.title}</h2>
              <p>{p.text}</p>
              <ul>{p.points.map((pt) => <li key={pt}><Icon name="check" size={16} stroke={2.6} />{pt}</li>)}</ul>
              <span className={`bx-btn bx-btn-lg bx-btn-block ${p.key === 'consumer' ? 'bx-btn-primary' : 'bx-btn-secondary'}`} aria-hidden="true">
                {p.cta} <Icon name="arrow" />
              </span>
            </div>
          </button>
        ))}
      </div>
      <div className="bx-alert brand" style={{ marginTop: 18 }}>
        <Icon name="shield" /> <span><strong>No drama delivery.</strong> Everything arrives in plain, unlabelled bags with BOQBOX riders.</span>
      </div>
    </FlowPage>
  );
}
